module.exports = __webpack_public_path__ + "media/images/extension-onboarding/step1-2fb14d1e3cf100353d465e7a1f9b1be9.gif";